// extracted by mini-css-extract-plugin
export default {"smallButton":"button_smallButton__c7gLS"};